<template>
  <div class="inline-block w-100">
    <input
      class="patch float-right"
      type="color"
      v-model="color"
      @change="updateColor"
    />
    <input
      class="txt float-right"
      v-model="color"
      @change="updateColor"
      @focus="$event.target.select()"
    />
  </div>
</template>
<script>
export default {
  name: "ColorPaletteSelector",
  props: ["initialColor"],

  data() {
    return {
      color: this.initialColor,
    };
  },
  methods: {
    updateColor() {
      const component = this;
      this.$root.$emit("update-color", component.initialColor, component.color);
    },
  },
};
</script>
<style scoped>
.patch {
  display: inline-block;
  width: 60px;
  height: 20px;
  border: 1px solid gray;
  margin-bottom: -5px;
}
.txt {
  width: 80px;
  height: 20px;
  font-family: "Courier New", Courier, monospace; /* fallback for IE */
  font-family: value; /* fallback for IE */
  font-family: var(--monospace-font-family);
}
</style>